import { createSlice } from '@reduxjs/toolkit';

const loadingSlice = createSlice({
  name: 'loading',
  initialState: {
    isLoading: false,
    loadingMessage: 'Loading...'
  },
  reducers: {
    showLoading: (state, action) => {
      state.isLoading = true;
      state.loadingMessage = action.payload || 'Loading...';
    },
    hideLoading: (state) => {
      state.isLoading = false;
      state.loadingMessage = 'Loading...';
    }
  }
});

export const { showLoading, hideLoading } = loadingSlice.actions;
export default loadingSlice.reducer;